import { Box, Divider, RadioGroup, Tooltip, Typography, useTheme, IconButton } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";

export default function QuestionItem({
  question,
  answers,
  handleAnswerSelect,
  index,
  isMarked,
  onToggleMark,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        pt: 0,
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Divider sx={{ mb: 2, borderColor: "dark-gray" }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="h6"
          component="h5"
          sx={{ fontWeight: 600, color: "dark-gray" }}
        >
          Question {question.number || index + 1}
        </Typography>
        {onToggleMark && (
          <Tooltip
            title={isMarked ? "Unmark question" : "Mark for review"}
          >
            <IconButton
              size="small"
              onClick={() => onToggleMark(question)}
              sx={{
                color: isMarked ? theme.palette.warning.main : "text.secondary",
              }}
            >
              {isMarked ? (
                <PushPinIcon fontSize="small" />
              ) : (
                <PushPinOutlinedIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Typography variant="body1" component="p" sx={{ mt: 1, userSelect: "none" }}>
        {question.question}
      </Typography>

      <RadioGroup
        value={answers[question._id] || ""}
        onChange={(e) => handleAnswerSelect(question._id, e.target.value)}
        sx={{ width: "100%" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // flexDirection: currentSection === SECTION.LISTENING ? "row" : "column",
            gap: 0,
            // justifyContent: currentSection === SECTION.LISTENING ? "space-between" : "start",
            // flexWrap: "wrap",
          }}
        >
          {question.choices.map((option, idx) => {
            const optionChar = String.fromCharCode(65 + idx);
            const isSelected = answers[question._id] === option.value;
            
            return (
              <Box
                key={`${question._id}-${idx}`}
                onClick={() => handleAnswerSelect(question._id, option.value)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  p: 0.5,
                }}
              >
                <Box 
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    minWidth: 32,
                    minHeight: 32,
                    borderRadius: '50%',
                    bgcolor: isSelected ? theme.palette.primary.main : 'white',
                    border: '1px solid',
                    borderColor: isSelected ? theme.palette.primary.main : 'black',
                    color: isSelected ? 'white' : 'black',
                    mr: 2,
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    boxSizing: 'border-box',
                    flexShrink: 0,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      bgcolor: isSelected ? theme.palette.primary.main : theme.palette.grey[200],
                    },
                  }}
                >
                  {optionChar}
                </Box>
                <Typography variant="body1" sx={{ userSelect: "none" }}>
                  {option.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </RadioGroup>
    </Box>
  );
}

